// extracted by mini-css-extract-plugin
export default {"container":"surtitle_container__RBjdz"};